import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import { EnvironmentService } from "@/environment/environmentservice";
import { SearchService } from "@/search/searchservice";
import router from "./router";
import "@/global.ts";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import VueCookies from "vue-cookies";
import VuetifyToast from "vuetify-toast-snackbar";

import "vue-class-component/hooks";
import { Route, RawLocation } from "vue-router";
import store from "@/store/index";

import "@/plugins/register-hooks";
import Vuelidate from "vuelidate";

Vue.use(Vuelidate);
Vue.use(VueCookies);
Vue.use(VuetifyToast, {
    classes: ["snackbar"],
    timeout: 30000,
    x: "bottom",
    y: "bottom",
    dismissable: true,
    queueable: true,
    property: "$toast",
});

const environmentService = new EnvironmentService();
const searchService = new SearchService();

declare module "vue/types/vue" {
    interface Vue {
        $environmentService: EnvironmentService;
        $searchService: SearchService;
        beforeRouteEnter?(
            to: Route,
            from: Route,
            next: (to?: RawLocation | false | ((vm: Vue) => void)) => void
        ): void;

        beforeRouteLeave?(
            to: Route,
            from: Route,
            next: (to?: RawLocation | false | ((vm: Vue) => void)) => void
        ): void;

        beforeRouteUpdate?(
            to: Route,
            from: Route,
            next: (to?: RawLocation | false | ((vm: Vue) => void)) => void
        ): void;
    }
}

Vue.config.productionTip = false;
Vue.prototype.$environmentService = environmentService;
Vue.prototype.$searchService = searchService;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
